import { CONFIG } from '../config';

export interface LoginSession {
    isLoggedIn: boolean;
    userName?: string | null;
}

export async function getLoginSession(): Promise<LoginSession> {
    try {
        const response = await fetch(
            `${CONFIG.API_BASE_URL}/api/app/auth-session`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    accept: 'application/json'
                }
            }
        );

        if (!response.ok) {
            return {
                isLoggedIn: false
            };
        }

        return await response.json();
    } catch {
        return {
            isLoggedIn: false
        };
    }
}
export async function logoutSession() {
    await fetch(
        `${CONFIG.API_BASE_URL}/api/app/auth-session/logout`,
        {
            method: 'POST',
            credentials: 'include'
        }
    );
}